(function () {
  function apply() {
    try {
      var cfg = window.scrollConfig || {};
      var mode = cfg.mode || 'native';
      var reduce = cfg.respectReducedMotion &&
        window.matchMedia &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var touch = cfg.disableOnTouch && (
        'ontouchstart' in window ||
        navigator.maxTouchPoints > 0 ||
        (window.matchMedia && window.matchMedia('(pointer: coarse)').matches)
      );
      if (reduce || touch) mode = 'native';

      var root = document.documentElement;
      var body = document.body;

      if (mode === 'css_smooth') {
        root.style.scrollBehavior = 'smooth';
        body.style.scrollBehavior = 'smooth';
        return;
      }

      function setAuto() {
        root.style.scrollBehavior = 'auto';
        body.style.scrollBehavior = 'auto';
      }

      function initLenis() {
        if (typeof window.Lenis !== 'function') {
          root.style.scrollBehavior = 'smooth';
          body.style.scrollBehavior = 'smooth';
          return;
        }
        setAuto();
        var lenis = new window.Lenis({
          duration: (cfg.lenis && cfg.lenis.duration) || 1,
          wheelMultiplier: (cfg.lenis && cfg.lenis.wheelMultiplier) || 1
        });
        function raf(time) {
          lenis.raf(time);
          requestAnimationFrame(raf);
        }
        requestAnimationFrame(raf);
      }

      if (mode === 'lenis') {
        if (cfg.lenis && cfg.lenis.assetUrl) {
          var s = document.createElement('script');
          s.src = cfg.lenis.assetUrl;
          s.async = true;
          s.onload = initLenis;
          s.onerror = function () {
            root.style.scrollBehavior = 'smooth';
            body.style.scrollBehavior = 'smooth';
          };
          document.head.appendChild(s);
        } else {
          initLenis();
        }
        return;
      }

      if (mode === 'raf_smooth') {
        setAuto();
        var smooth = (cfg.raf && cfg.raf.smooth) || 0.2;
        var current = window.pageYOffset;
        var target = current;
        var ticking = false;
        function update() {
          current += (target - current) * smooth;
          window.scrollTo(0, current);
          if (Math.abs(target - current) > 0.5) {
            requestAnimationFrame(update);
          } else {
            ticking = false;
          }
        }
        function requestTick() {
          if (!ticking) {
            requestAnimationFrame(update);
            ticking = true;
          }
        }
        function onWheel(e) {
          target += e.deltaY;
          requestTick();
          e.preventDefault();
        }
        function onKey(e) {
          var step = 100;
          if (e.key === 'ArrowDown') target += step;
          else if (e.key === 'ArrowUp') target -= step;
          else return;
          requestTick();
          e.preventDefault();
        }
        window.addEventListener('wheel', onWheel, { passive: false });
        window.addEventListener('keydown', onKey, { passive: false });
        window.addEventListener(
          'scroll',
          function () {
            if (!ticking) {
              current = target = window.pageYOffset;
            }
          },
          { passive: true }
        );
        return;
      }
    } catch (e) {
      console.error(e);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
})();
